import LinkedTelegramAccounts from './LinkedTelegramAccounts';

export default LinkedTelegramAccounts;
